<template>
  <td class="name">{{ stat.toUpperCase() }}</td>
  <td class="value">{{ abilities[stat] }}</td>
  <td class="mod"><Dice :dice="stat" :label="longName" noexpr /></td>
  <td class="save"><Dice v-if="saveExpr" :dice="saveExpr" :label="`${longName} save`" noexpr /></td>
</template>

<script setup lang="ts">
import { ensurePrefix, stringify } from '../util'
import { type StatblockData, type Ability, resolveAbilityScores, statnames } from './statblock'

const props = defineProps<{
  stats: StatblockData
  stat: Ability
}>()

const abilities = computed(() => resolveAbilityScores(props.stats))

const longName = computed(() => statnames[props.stat])

const saveExpr = computed(() => {
  const prof = (props.stats.saves || []).includes(props.stat.toUpperCase()) ? '+prof' : ''
  const bonus = props.stats.savesBonus ? ensurePrefix(stringify(props.stats.savesBonus), '+') : ''
  return `${props.stat}${prof}${bonus}`
})
</script>
